import React from 'react';
import PPLogo from '~/Assets/Images/Brand/pp-logo.svg';
import { BACKGROUND_PRIMARY } from '~/Constants/Colors.constants';
import { AppBar, Toolbar } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(
  (theme) => ({
    userName: {
      fontWeight: 'bold',
    },
    avatar: {
      marginRight: theme.spacing(2),
    },
    toolbar: {
      backgroundColor: BACKGROUND_PRIMARY,
      padding: '32px 0',
      justifyContent: 'center',
    },
    logo: {
      width: '80%',
      height: 'auto',
    },
    closeButton: {
      fontSize: 12,
      height: 28,
    },
  }),
  { name: 'DrawerHeader' },
);

export const DrawerHeader = () => {
  const { classes } = useStyles();
  return (
    <AppBar elevation={0} position="static">
      <Toolbar className={classes.toolbar}>
        <img src={PPLogo} className={classes.logo} alt="PP Logo" />
      </Toolbar>
    </AppBar>
  );
};
